<script>
    import {sgettext} from '../../../i18n.js';
    export let mechanism = null;
    export let hazard = null;
    export let control = null;
    export let isVerticalLayout = false;
</script>

<style>
    .wrapper {
        background-color: #dd5900;
        padding: 15px;
        color: white;
        margin-bottom: 30px;
    }

    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 8px;
    }

    .grid-vertical {
        display: grid;
        grid-template-columns: 1fr;
        column-gap: 8px;
    }

    .grid-vertical .hc-item {
        margin-bottom: 12px;
    }

    .hc-item {
        display: grid;
        grid-template-columns: 64px 1fr;
        column-gap: 16px;
    }

    .hc-item .icon {
        width: 100%;
        overflow: hidden;
        font-size: 10px;
    }

    .hc-item .icon img {
        width: 64px;
    }

    .content .name {
        font-weight: bold;
    }
</style>

{#if hazard || control}
<div class="wrapper">
    <p>{sgettext('$$MATERIAL_RISK_ELEMENT_CONTROLLING$$')}</p>
    <div class="{isVerticalLayout ? 'grid-vertical' : 'grid'}">
        <div class="hc-item">
            {#if mechanism?.energy_type}
                <div class="icon">
                    {#if mechanism.energy_type.icon}
                    <img src={mechanism.energy_type.icon.url} alt={mechanism.energy_type.name} />
                    {/if}
                </div>
                <div class="content">
                    <div class="name">{mechanism.energy_type.name}</div>
                    <div>{mechanism.name}</div>
                </div>
            {/if}
        </div>
        <div class="hazard hc-item">
            <div class="icon">
                {#if hazard.icon}
                <img src={hazard.icon.url} alt={hazard.icon.name} />
                {/if}
            </div>
            <div class="content">
                <div class="name">{hazard.name}</div>
                <div>{hazard.description}</div>
            </div>
        </div>
        <div class="control hc-item">
            <div class="icon">
                {#if control.icon}
                <img src={control.icon.url} alt={control.icon.name} />
                {/if}
            </div>
            <div class="content">
                <div class="name">{control.name}</div>
                <div>{control.description}</div>
            </div>
        </div>
    </div>
</div>
{/if}